import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { VOLUNTEER_FORM } from "src/constants";
import { Link } from "gatsby";
import * as React from "react";
import { Helmet } from "react-helmet";
import Blockquote from "src/components/Blockquote";
import Container from "src/components/Container";
import ImageHeaderUnit from "src/components/ImageHeaderUnit";
import Layout from "src/components/Layout";
import Paragraph from "src/components/Paragraph";
import SubHeader from "src/components/SubHeader";
import edvitaImg from "src/images/work-with-us/Edvita Kelley-Smith.jpg";
import bg from "src/images/work-with-us/work-with-us-bg.jpg";
import volunteerImg from "src/images/work-with-us/volunteer.jpg";

const JOBS = [
  {
    title: "Executive Director",
    url: "https://www.paycomonline.net/v4/ats/web.php/jobs/ViewJobDetails?job=90419&clientkey=1EB32FC627C2A157DE15C7A11F456F77",
  },
  {
    title: "Manager of Case Managers in ES",
    url: "https://www.paycomonline.net/v4/ats/web.php/jobs/ViewJobDetails?job=155630&clientkey=1EB32FC627C2A157DE15C7A11F456F77",
  },
  {
    title: "HSP Case Manager Family Unit in RR",
    url: "https://www.paycomonline.net/v4/ats/web.php/jobs/ViewJobDetails?job=149200&clientkey=1EB32FC627C2A157DE15C7A11F456F77",
  },
  {
    title: "MC Family Case Manager of Transitional Housing",
    url: "https://www.paycomonline.net/v4/ats/web.php/jobs/ViewJobDetails?job=157425&clientkey=1EB32FC627C2A157DE15C7A11F456F77",
  },
  {
    title: "CES Intake Assessor",
    url: "https://www.paycomonline.net/v4/ats/web.php/jobs/ViewJobDetails?job=134674&clientkey=1EB32FC627C2A157DE15C7A11F456F77",
  },
  {
    title: "Respite Care Program Assistant",
    url: "https://www.paycomonline.net/v4/ats/web.php/jobs/ViewJobDetails?job=86235&clientkey=1EB32FC627C2A157DE15C7A11F456F77",
  },
  {
    title: "Housing Advocate (Crossroads, FM, OH, MC)",
    url: "https://www.paycomonline.net/v4/ats/web.php/jobs/ViewJobDetails?job=104116&clientkey=1EB32FC627C2A157DE15C7A11F456F77",
  },
  {
    title: "Prep Cook/Deliver Meals",
    url: "https://www.paycomonline.net/v4/ats/web.php/jobs/ViewJobDetails?job=102170&clientkey=1EB32FC627C2A157DE15C7A11F456F77",
  },
  {
    title: "Maintenance Technician",
    url: "https://www.paycomonline.net/v4/ats/web.php/jobs/ViewJobDetails?job=83008&clientkey=1EB32FC627C2A157DE15C7A11F456F77",
  },
  {
    title:
      "Board Member (Voluntary Position – Currently need Board Member with Shelter Experience and Success)",
    url: "https://www.paycomonline.net/v4/ats/web.php/jobs/ViewJobDetails?job=96394&clientkey=1EB32FC627C2A157DE15C7A11F456F77",
  },
];

const QUOTES = [
  {
    name: "Edvita Kelley-Smith",
    position: "Director of Shelter Programs",
    quote: (
      <>
        I love EOCP because{" "}
        <b>I get to witness firsthand the incredible impact we’re making</b> in
        one of the most vulnerable areas of our community-housing the unhoused.
        It’s more than just placing someone in a unit; it’s about restoring
        dignity, hope, and stability-not only for individuals, but for their
        families as well.{" "}
        <b>
          Being part of work that changes lives at such a deep level is truly an
          honor.
        </b>
      </>
    ),
    img: edvitaImg,
  },
];

export default function WorkWithUsPage() {
  return (
    <Layout>
      <Helmet>
        <title>Work With Us</title>
      </Helmet>
      <ImageHeaderUnit
        subtitle="Work With Us"
        title="Join Our Team"
        img={bg}
        backgroundPosition="50% 15%"
        maxTitleWidth={"15em"}
      />
      <Container>
        <Grid container spacing={{ sm: 6, md: 4 }}>
          <Grid item xs={12} sm={6}>
            <Box mb={4}>
              <SubHeader>Open Roles</SubHeader>
              <Paragraph>
                We welcome candidates from a wide range of backgrounds to
                support our team’s committed work. Check out our openings to see
                if there’s a fit for you at EOCP!
              </Paragraph>

              <Box mb={2}>
                {JOBS.length === 0 && (
                  <Typography variant="subtitle1">
                    <i>No open roles at this time.</i>
                  </Typography>
                )}
                {JOBS.map(({ title, url }) => {
                  return (
                    <Button
                      key={url}
                      fullWidth
                      component={Link}
                      to={url}
                      variant="contained"
                      sx={{ mt: 1, justifyContent: "start" }}
                    >
                      {title}
                    </Button>
                  );
                })}
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <SubHeader>Our philosophy and values</SubHeader>
            <Blockquote my={0} mb={3}>
              East Oakland Community Project is led by dedicated and
              compassionate staff who serve people and families experiencing
              homelessness with a high level of responsibility and integrity.
              <br />
              <br />
              Across the organization, we value diversity in all its forms,
              embrace initiative and a strong ethic of caring for others, and
              support personal growth and positive change. We work
              collaboratively and inclusively across residents, staff, board,
              and the greater community!
            </Blockquote>
          </Grid>
        </Grid>
        <SubHeader>In the words of our staff...</SubHeader>
        <Grid container spacing={{ sm: 6, md: 4 }}>
          {QUOTES.map(({ quote, name, position, img }) => (
            <Grid item xs={12} sm={6} md={4} key={name} mb={3} container>
              <Paragraph>
                <Box
                  component="img"
                  src={img}
                  alt={name}
                  sx={{
                    width: { xs: "33vw", sm: "20vw", md: "100%" },
                    float: { xs: "left", md: "none" },
                    mr: { xs: 3, md: 0 },
                  }}
                  mb={2}
                />
                {quote}
                <Typography
                  variant="body2"
                  component="span"
                  display="block"
                  mt={2}
                >
                  <b>— {name},</b> {position}
                </Typography>
              </Paragraph>
            </Grid>
          ))}
        </Grid>
        <Box display={{ sm: "flex" }}>
          <Box>
            <Box
              component="img"
              src={volunteerImg}
              sx={{
                display: "block",
                mx: "auto",
                mr: { sm: 3 },
                mb: 3,
                width: { xs: "100%", sm: "33vw" },
                maxWidth: 320,
              }}
            />
          </Box>
          <Box>
            <Box my={4}>
              <SubHeader>Volunteer</SubHeader>
              <Paragraph>
                We’d love to learn about your interest in volunteering! Please
                complete our interest form, and we will contact you as soon as
                opportunities are available.
              </Paragraph>
              <Button variant="contained" href={VOLUNTEER_FORM} component="a">
                Volunteer Interest Form
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>
    </Layout>
  );
}
